export { Resume } from './Resume';

export type { ResumeProps } from './Resume';
